import { render, staticRenderFns } from "./select-store.vue?vue&type=template&id=122be567"
import script from "./select-store.vue?vue&type=script&lang=js"
export * from "./select-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports